import React from "react";
import Image from "components/image";
import RichText from "components/rich-text";

const components = {
  normal: ({ children }) => (
    <p className="paragraph-normal text-gray-800 xsm:text-base leading-7 mb-5">
      {children}
    </p>
  )
};

const BreedingDetails = ({ data }) => {
  return (
    <div>
      <h2 className="font-display font-bold text-h2 text-green-800 mb-6">
        {data.title}
      </h2>
      {data.description?.data && 
        <RichText value={data.description?.data} components={components} />
      }
      <div className="bg-green-800 rounded-sm">
        <img src={data.image?.src} className="w-full " />
      </div>
      <div className="h-px w-full bg-gray-300 my-8" />
    </div>
  );
};

export default BreedingDetails;
